// extracted by mini-css-extract-plugin
module.exports = {"featuresActionContainer":"style-module_featuresActionContainer__NF_BZgvhGoAcAG9pZAFOK"};